import { useEffect } from "react";

const NeutralinoShortcuts = () => {
  useEffect(() => {
    const handleKeyPress = async (event: KeyboardEvent) => {
      const isCtrlOrCmd = event.ctrlKey || event.metaKey;

      switch (event.key) {
        case "z":
          if (isCtrlOrCmd) {
            event.preventDefault();
            document.execCommand("undo");
          }
          break;
        case "c":
          if (isCtrlOrCmd) {
            try {
              await navigator.clipboard.writeText(
                window.getSelection()?.toString() ?? "",
              );
            } catch (err) {
              console.error("Failed to copy: ", err);
            }
          }
          break;
        case "v":
          if (isCtrlOrCmd) {
            console.log("Global paste handler triggered");

            // Check if the focused element has its own paste handling
            const activeElement = document.activeElement as HTMLElement;
            const hasCustomPasteHandler =
              activeElement?.hasAttribute("data-custom-paste") ||
              activeElement
                ?.getAttribute("data-testid")
                ?.includes("code-input") ||
              activeElement?.closest("[data-custom-paste]");

            if (hasCustomPasteHandler) {
              console.log(
                "Skipping global paste - element has custom paste handler",
              );
              return; // Let the element's own paste handler take care of it
            }

            console.log("Executing global paste handler");
            try {
              const text = await navigator.clipboard.readText();
              document.execCommand("insertText", false, text);
            } catch (err) {
              console.error("Failed to paste: ", err);
            }
          }
          break;
        case "q":
          if (isCtrlOrCmd) {
            // Make sure Neutralino API is available
            if (window.Neutralino?.app) {
              window.Neutralino.app.exit();
            } else {
              console.warn("Neutralino API not available");
            }
          }
          break;
        // Add more shortcuts as needed
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return null; // This component doesn't render anything
};

export default NeutralinoShortcuts;
